import { withSuspenseLazy } from 'react-with-suspense-lazy';

import { AuthorRoutePaths } from '../routesPaths';
import { RoutesConfiguration } from '@components/RouterOutlet';
import { permissionsRoles } from '@config/permissions';
import { Loader } from '@components/Loader';

const AuthorPage = withSuspenseLazy(
  () => import('./AuthorPage'),
  Loader,
);

const AuthorAdd = withSuspenseLazy(
  () => import('./AuthorAdd'),
  Loader,
);

const AuthorEdit = withSuspenseLazy(
  () => import('./AuthorEdit'),
  Loader,
);

const AuthorBooks = withSuspenseLazy(
  () => import('./AuthorBooks'),
  Loader,
);

export const AuthorRouteConfig: RoutesConfiguration = [
  {
    path: AuthorRoutePaths.authorRoot,
    component: AuthorPage,
    exact: true,
    permittedRoles: permissionsRoles.author,
  },
  {
    path: AuthorRoutePaths.authorAddPath,
    component: AuthorAdd,
    permittedRoles: permissionsRoles.author,
  },
  {
    path: AuthorRoutePaths.authorEditPath,
    component: AuthorEdit,
    permittedRoles: permissionsRoles.author,
  },
  {
    path: AuthorRoutePaths.authorBooksPath,
    component: AuthorBooks,
    permittedRoles: permissionsRoles.author,
  },
];
